/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { compose } from "redux";
import MasterService from "../../services/MasterService";
import CountryService from "../../services/CountryService";
import "../../public/common.css";
import { showLoading } from 'react-global-loading';

class CountryHeader extends React.Component {
  constructor(props) {
    super(props);

    window.scrollTo(0, 0);
    this.state = {
      categories: [],
      selectedCategory: "",
      countryId: props.match.params.id,
      countryName: props.match.params.country,
    };
  }

  componentDidMount = () => {
    // showLoading(true);
    this.getAllCategories();
    this.getCountryDetails();
  };

  getCountryDetails = () => {
    CountryService.countryDetail({ 'blog_id': this.state.countryId })
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countryData: result[0] });

        // showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  getAllCategories = () => {
    MasterService.getCategories()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({
          categories: result,
          selectedCategory: this.props.category ? result.find(obj => obj.name === this.props.category) : result[0]
        });
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };
  onTrigger = (item) => {
    // showLoading(true);
    this.setState({ selectedCategory: item })
    // Call the parent callback function
    this.props.parentCallback(
      item
    );

    const url = new URL(window.location);
    let newUrl = '', finUrl = '';

    url.href.includes('%20') ? (newUrl = url.href.replace('%20', " "), finUrl = newUrl.replace(this.props.match.params.catId, item.name)) : finUrl = url.href.replace(this.props.match.params.catId, item.name)

    window.location.href = finUrl;
    // showLoading(false);
  };
  render() {
    const {
      categories,
      selectedCategory,
      countryData,
      countryName,
    } = this.state;
    console.log("demo====", selectedCategory)
    return (
      <>
        <section id="ayushBranch">
          <div className="container">
            <div className="d-flex justify-content-between align-items-start domscr">
              {categories.map((item, index) => (
                <div
                  key={index}
                  className={`branch d-flex justify-content-center flex-column brhwr${selectedCategory?.id === item.id ? "_hvr" : ``
                    }`}
                >
                  <span
                    className="iconwrp"
                    onClick={() => this.onTrigger(item)}
                  >
                    <img
                      src={item.img_cat[0]}
                      className="img-fluid imbr_h"
                      alt="Ayurveda"
                    />
                  </span>
                  <span className="domnam">{item.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="pageMusthead">
          <div className="container">
            <div className="row gx-5">

              <div className="col-md-2 col-sm-12">
                <div className="countryImg-info">
                  {/* <img src="assets/images/country-img.jpg" width="100%" className="img-fluid" alt="country img"/> */}
                  <span>
                    <img
                      src={countryData?.mission_image}
                      className="img-fluid"
                      alt="country map"
                    />
                  </span>
                </div>
              </div>
              <div className="col-md-10 col-sm-12 px-5">
                <div className="countryText-info">
                  <div
                    style={{
                      position: "relative",
                      width: "max-content",
                      marginBottom: "2rem",
                    }}
                  >
                    <div className="countryhdd">
                      <h2 className="countryhd_txt">{countryData?.post_title}</h2>
                    </div>
                    <div className="num2"></div>
                    <div className="num3"></div>
                  </div>
                  {/* <h5> {countryData?.post_title}</h5> */}
                  <p>{countryData?.post_content} </p>
                </div>
              </div>
            </div>
          </div>
        </section>


      </>
    );
  }
}
const mapStateToProps = state => {
  return { translation: state.translation };
};

export default compose(connect(mapStateToProps, null), withRouter)(CountryHeader);
